import { createI18n } from 'vue-i18n'
import uz from './locales/uz.json'
import en from './locales/en.json'
import ru from './locales/ru.json'
import uzCrl from './locales/uz-crl.json'

// Get saved locale from localStorage or use default
const savedLocale = localStorage.getItem('locale') || 'uz'

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: savedLocale,
  fallbackLocale: 'uz',
  messages: {
    uz,
    en,
    ru,
    'uz-crl': uzCrl
  },
  globalInjection: true, // Enable $t() in templates
  missingWarn: process.env.NODE_ENV === 'development',
  fallbackWarn: process.env.NODE_ENV === 'development'
})

export default i18n
